(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.BromicCanadaPlatinumGift = api;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var TRIGGER_VARIANT_IDS = [46884085432487, 46928552755367, 46884085465255, 46928552788135];
  var GIFT_VARIANT_ID = 46569784541351;
  var MINIMUM_TRIGGER_QUANTITY = 2;
  var MARKER_KEY = '_bromic_ca_platinum_gift';
  var MARKER_VALUE = 'onoff-2026';
  // 2026-10-31 23:59 Australia/Sydney (GMT+11) = 2026-10-31 12:59 UTC.
  var EXPIRY_MS = Date.parse('2026-10-31T23:59:00+11:00');

  function number(value) { return Number(value); }
  function items(cart) { return cart && Array.isArray(cart.items) ? cart.items : []; }
  function isManagedGift(item) {
    return number(item && (item.variant_id || item.id)) === GIFT_VARIANT_ID &&
      item.properties && item.properties[MARKER_KEY] === MARKER_VALUE;
  }

  function plan(cart, country, nowMs) {
    var cartItems = items(cart);
    var triggerQuantity = cartItems.reduce(function (sum, item) {
      return sum + (TRIGGER_VARIANT_IDS.indexOf(number(item.variant_id || item.id)) !== -1 ? number(item.quantity) || 0 : 0);
    }, 0);
    var managed = cartItems.filter(isManagedGift);
    var currentTime = nowMs === undefined ? Date.now() : number(nowMs);
    var shouldHaveGift = currentTime < EXPIRY_MS && country === 'CA' && triggerQuantity >= MINIMUM_TRIGGER_QUANTITY;
    var updates = {};

    if (!shouldHaveGift) {
      managed.forEach(function (item) { updates[item.key] = 0; });
      return { updates: updates, add: false };
    }

    managed.forEach(function (item, index) {
      var target = index === 0 ? 1 : 0;
      if (number(item.quantity) !== target) updates[item.key] = target;
    });
    return { updates: updates, add: managed.length === 0 };
  }

  function createClock(options) {
    options = options || {};
    var localNow = options.now || function () { return Date.now(); };
    var monotonicNow = options.monotonicNow || function () {
      return typeof performance !== 'undefined' && performance.now ? performance.now() : localNow();
    };
    var newestRequestStartedAt = -Infinity;
    var trusted = false;
    var baseServerTime;
    var baseMonotonic;
    var floor = -Infinity;

    function now() {
      var current = trusted ? baseServerTime + (monotonicNow() - baseMonotonic) : localNow();
      if (trusted && current < floor) return floor;
      floor = current;
      return current;
    }
    function observeServerDate(dateHeader, requestStartedAt, responseReceivedAt) {
      var serverTime = Date.parse(dateHeader || '');
      if (!isFinite(serverTime) || requestStartedAt < newestRequestStartedAt) return;
      newestRequestStartedAt = requestStartedAt;
      var receivedMonotonic = monotonicNow();
      var requestDuration = Math.max(0, number(responseReceivedAt) - number(requestStartedAt));
      var candidate = serverTime + requestDuration / 2;
      var currentTrusted = trusted ? baseServerTime + (receivedMonotonic - baseMonotonic) : -Infinity;
      if (trusted && candidate < Math.max(floor, currentTrusted)) return;
      baseServerTime = candidate;
      baseMonotonic = receivedMonotonic;
      trusted = true;
      floor = candidate;
    }
    return { now: now, observeServerDate: observeServerDate };
  }

  function createCheckoutGuard(options) {
    options = options || {};
    var reconcile = options.reconcile;
    var now = options.now || function () { return Date.now(); };
    var expiryMs = number(options.expiryMs);
    var managedGift = options.isManagedGift || isManagedGift;
    return async function () {
      try {
        var cart = await reconcile();
        return now() < expiryMs || !items(cart).some(managedGift);
      } catch (error) {
        if (now() < expiryMs) return true;
        throw error;
      }
    };
  }

  function createReconciler(options) {
    options = options || {};
    var queue = Promise.resolve();
    var request = options.request;
    var rootPath = options.root || '/';
    var country = options.country;
    var notify = options.onChanged;
    var now = options.now || function () { return Date.now(); };

    function path(name) {
      return rootPath.replace(/\/?$/, '/') + name;
    }
    function json(body) {
      return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      };
    }
    async function readCart() {
      return request(path('cart.js'), { headers: { Accept: 'application/json' } });
    }
    async function run() {
      var cart = await readCart();
      var action = plan(cart, country, now());
      var changed = false;
      if (Object.keys(action.updates).length) {
        cart = await request(path('cart/update.js'), json({ updates: action.updates }));
        changed = true;
      }
      if (action.add && now() < EXPIRY_MS) {
        await request(path('cart/add.js'), json({
          items: [{
            id: GIFT_VARIANT_ID,
            quantity: 1,
            properties: (function () {
              var properties = {};
              properties[MARKER_KEY] = MARKER_VALUE;
              return properties;
            })()
          }]
        }));
        cart = await readCart();
        changed = true;
        if (now() >= EXPIRY_MS) {
          var expiredUpdates = {};
          items(cart).filter(isManagedGift).forEach(function (item) { expiredUpdates[item.key] = 0; });
          if (Object.keys(expiredUpdates).length) {
            cart = await request(path('cart/update.js'), json({ updates: expiredUpdates }));
          }
        }
      }
      if (changed && notify) notify(cart);
      return cart;
    }
    function reconcile() {
      queue = queue.then(run, run);
      return queue;
    }
    return { reconcile: reconcile };
  }

  return {
    constants: {
      triggerVariantIds: TRIGGER_VARIANT_IDS.slice(),
      giftVariantId: GIFT_VARIANT_ID,
      markerKey: MARKER_KEY,
      markerValue: MARKER_VALUE,
      expiryMs: EXPIRY_MS
    },
    isManagedGift: isManagedGift,
    plan: plan,
    createClock: createClock,
    createCheckoutGuard: createCheckoutGuard,
    createReconciler: createReconciler
  };
});
